/** Client-safe intake bounds shared by browser capture and server validation. */
import { z } from "zod";

import { CLIENT_EVENT_TYPES, CONSENT_BUCKETS } from "~/lib/analytics/events";

export const MAX_BATCH_EVENTS = 50;

export const eventInputSchema = z.object({
  type: z.enum(CLIENT_EVENT_TYPES),
  // P9-05 · Shared browser/server de-dup id (UUID).
  eventId: z.string().min(1).max(64).optional(),
  path: z.string().max(2048).optional(),
  productId: z.string().max(64).optional(),
  variantId: z.string().max(64).optional(),
  searchQuery: z.string().max(256).optional(),
  // Integer only — a client can't send fractional quantities.
  quantity: z.number().int().min(0).max(100_000).optional(),
  props: z.record(z.unknown()).optional(),
});

export const attributionSchema = z.object({
  utmSource: z.string().max(256).optional(),
  utmMedium: z.string().max(256).optional(),
  utmCampaign: z.string().max(256).optional(),
  utmTerm: z.string().max(256).optional(),
  utmContent: z.string().max(256).optional(),
  referrer: z.string().max(2048).optional(),
  landingPath: z.string().max(2048).optional(),
});

export const trackInputSchema = z.object({
  events: z.array(eventInputSchema).min(1).max(MAX_BATCH_EVENTS),
  consentBucket: z.enum(CONSENT_BUCKETS),
  attribution: attributionSchema.optional(),
});

export type EventInput = z.infer<typeof eventInputSchema>;
export type TrackInput = z.infer<typeof trackInputSchema>;

